var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionOffices',{staticClass:"SectionContacts",attrs:{"background":_vm.background,"customQuery":{ type: { $in: ['PARDAVIMAI', 'Pardavimai'] } },"doShowType":_vm.doShowOfficeType}},[_c('h2',{staticClass:"title",attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }